import angular from 'angular';
import { IFolhaPonto } from '../../../models/folhaponto.model';

export class FolhasPontoCancelarAssinaturaModalService {

    static $inject = ['$uibModal'];

    constructor(
        private $uibModal: ng.ui.bootstrap.IModalService,
    ) {}

    public open(entity: IFolhaPonto): ng.ui.bootstrap.IModalInstanceService {
        return this.$uibModal.open({
            template: require('html-loader!./cancelarassinatura.modal.html'),
            controller: 'FolhasPontoCancelarAssinaturaModalController',
            controllerAs: '$ctrl',
            backdrop: 'static',
            resolve: {
                entity: () => angular.copy(entity),
            }
        });
    }
}
